import { useVisitorJs } from 'utils/services/visitor/useVisitorJs'

export const VisitorService = () => {
  useVisitorJs()
  return null
}
